var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        effect: "dark",
        content: _vm.$t.__("utilities.NotificationChip.mark_as_read"),
        placement: "bottom-end"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "chip-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$emit("clicked")
            }
          }
        },
        [_c("div", { staticClass: "chip label-chip primary-50-bkg m-auto" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }